// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__header___3D7yx{width:100%;display:flex;justify-content:space-between;align-items:center;height:72px;padding:24px;box-shadow:0px 0px 4px 0px rgba(0,0,0,0.15);position:relative}.styles-module__header___3D7yx>button{height:36px;border-radius:4px;padding:8px 12px;background-color:var(--primary-base);border:1px solid var(--primary-base);display:flex;align-items:center}.styles-module__certificateText___1hswe{font-size:20px;font-weight:600}\n", ""]);
// Exports
exports.locals = {
	"header": "styles-module__header___3D7yx",
	"certificateText": "styles-module__certificateText___1hswe"
};
module.exports = exports;
